import usersService from './usersService';

export default usersService;